import React, { Component } from 'react';
import { Link } from 'react-router-dom';

export default class CoverageBreadCrumbs extends Component {
  render() {
    return (
      <nav>
        <div className="breadcrumbs">
          <div className="breadcrumb">
            <Link to="/">Home</Link>
          </div>
          <div className="breadcrumb">
            <span>AWS Code Coverage</span>
          </div>
        </div>
      </nav>
    )
  }
}
